import React, { useCallback, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { toast } from "react-toastify"

import './onboarding.css'
import logoPretzu from '../../assets/logos_pretzu/logo_login.svg'

import { fetchSinToken } from '../../helpers/fetch'
import { CircularProgress, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { CircleCheck } from "lucide-react";

import { startLogin } from '../../redux/actions/auth';

const sectorList = [
    { id: 1, nombre: 'Arquitectura y construcción' },
    { id: 2, nombre: 'Agencias y creativos' },
    { id: 3, nombre: 'Consultoria y servicios' },
    { id: 4, nombre: 'Eventos y producciones' },
    { id: 5, nombre: 'Desarrollo de software' },
    { id: 6, nombre: 'Otro' }
]

export const OnboardingSignup = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate()

    const [msgError, setMsgError] = useState('')
    const [loading, setLoading] = useState(false)
    const [loadingCreando, setLoadingCreando] = useState(false)

    const [form, setForm] = useState({
        code: '',
        nombre: '',
        apellidos: '',
        email: '',
        nombre_empresa: '',
        id_pais: 2, // perú
        cod_pais: '+51',
        nombre_pais: 'Perú',
        nro_telefono: '',
        password: '',
        id_maestra_industrias: null
    })

    const checkLocalCode = useCallback(async () => {
        const activationCode = localStorage.getItem('p-activation-code') || '';

        if (activationCode === '') {
            alert('No se pudo validar la activación. Por favor vuelve a iniciar el proceso para crear tu cuenta en opción registrarse.')
            navigate('/login')
            return false
        }

        const resultCheck = await checkCodeConfirm(activationCode)
        if (!resultCheck.ok) {
            alert(resultCheck.msg)
            navigate('/login')
            return false
        }

        setForm(prev => ({
            ...prev,
            code: resultCheck.data.codigo_activacion,
            email: resultCheck.data.email
        }))

    }, [navigate])

    const checkCodeConfirm = async (code) => {
        const resp = await fetchSinToken('onboarding/confirm/code', { codigo_activacion: code }, 'POST');
        const body = await resp.json();
        return body
    }

    const handleSignup = async (e) => {
        try {
            e.preventDefault();

            setMsgError('')

            if (form.nombre === '') {
                setMsgError('Falta ingresar nombre')
                return false
            }

            if (form.apellidos === '') {
                setMsgError('Falta ingresar apellido')
                return false
            }

            if (form.nombre_empresa === '') {
                setMsgError('Falta ingresar nombre empresa')
                return false
            }

            if (form.id_maestra_industrias === '' || form.id_maestra_industrias === null) {
                setMsgError('Falta ingresar tu sector')
                return false
            }

            if (form.password === '') {
                setMsgError('Falta ingresar una contraseña')
                return false
            }

            if (form.password.length < 6) {
                setMsgError('Contraseña debe tener al menos 6 digitos')
                return false
            }

            if (form.password === '123456' || form.password === '654321' || form.password === '1234567' || form.password === '7654321') {
                setMsgError('Contraseña poco segura')
                return false
            }

            setLoading(true)
            setLoadingCreando(true)

            const resp = await fetchSinToken('onboarding/confirm/register', form, 'POST');
            const body = await resp.json();

            if (body.ok) {

                toast.success(body.msg)
                dispatch(startLogin(form.email, form.password))
                navigate('/login')

            } else {
                setMsgError(body.msg)
            }

            setLoading(false)
            setLoadingCreando(false)

        } catch (error) {

            setMsgError('Error interno')
            console.log(error)

            setLoading(false)
            setLoadingCreando(false)

        }

    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    useEffect(() => {
        checkLocalCode()
    }, [checkLocalCode])

    return (
        <div className='container'>
            <div className='row d-flex justify-content-center ContainerLogin'>

                <div className="col-md-5">

                    <div className="flex justify-center mt-4">
                        <img src={logoPretzu} alt="logo pretzu" />
                    </div>

                    {loadingCreando &&
                        <div className='text-center mt-5'>
                            <CircularProgress color="secondary" />
                            <h5 className='mt-4' style={{ color: '#4a24aa', fontSize: '16px' }}>Estamos creando tu cuenta</h5>
                            <h5 style={{ color: '#4a24aa', fontSize: '16px' }}>espere un momento</h5>
                        </div>
                    }

                    {!loadingCreando &&
                        < div className='row m-3'>
                            <div className="col text-center p-content-title-recover-password">
                                <h1 className='p-title-recover-password'>Estás a un paso de simplificar las finanzas de tus proyectos.</h1>
                            </div>
                        </div>
                    }

                    {!loadingCreando &&
                        <form className='login m-2' onSubmit={handleSignup}>

                            <div className='row m-3'>
                                <div className="col text-center">
                                    <h5 className='p-text-recover-password'>Completa tu registro llenando tus datos</h5>
                                </div>
                            </div>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div className='relative'>
                                        <TextField
                                            label="Tu email"
                                            name="email"
                                            color="success"
                                            value={form.email || ''}
                                            size="small"
                                            fullWidth
                                            disabled
                                            InputProps={{
                                                sx: {
                                                    "& input": {
                                                        textTransform: "lowercase",
                                                        backgroundColor: 'white'
                                                    },
                                                },
                                            }}
                                        />
                                        <div className='absolute right-5 top-3 flex justify-center items-center'>
                                            <span className='text-green-700 text-[13px]'>Verificada</span>
                                            <CircleCheck size={17} fill="green" color="white" className="ms-1" />
                                        </div>
                                    </div>

                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Tu nombre"
                                        name="nombre"
                                        id="outlined-size-small"
                                        value={form.nombre || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese tu nombre'
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        label="Tu apellido"
                                        name="apellidos"
                                        id="outlined-size-small"
                                        value={form.apellidos || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingresa tu apellido'
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label="Nombre de la empresa"
                                        name="nombre_empresa"
                                        id="outlined-size-small"
                                        value={form.nombre_empresa || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese nombre empresa'
                                        onChange={handleChange}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <FormControl fullWidth size="small">
                                        <InputLabel id="demo-simple-select-label">Sector</InputLabel>
                                        <Select
                                            label="Sector"
                                            id="id_maestra_industrias"
                                            name="id_maestra_industrias"
                                            value={form.id_maestra_industrias || ''}
                                            onChange={handleChange}
                                            className='p-list-capitalize'
                                        >
                                            <MenuItem value='' key=''>Ninguno</MenuItem>
                                            {sectorList.map(item => (
                                                <MenuItem value={item.id} key={item.id} className='p-list-capitalize'>{item.nombre}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <TextField
                                        type="password"
                                        label="Contraseña de acceso"
                                        name="password"
                                        id="outlined-size-small"
                                        value={form.password || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='Ingrese contraseña'
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        style={{ textAlign: 'center' }}
                                        label="País"
                                        name="cod_pais"
                                        id="outlined-size-small"
                                        value={form.cod_pais || ''}
                                        size="small"
                                        fullWidth
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={9}>
                                    <TextField
                                        label="Número de teléfono (opcional)"
                                        name="nro_telefono"
                                        id="outlined-size-small"
                                        value={form.nro_telefono || ''}
                                        size="small"
                                        fullWidth
                                        placeholder='999 888 777'
                                        onChange={handleChange}
                                    />
                                </Grid>
                            </Grid>

                            {msgError !== '' &&
                                <div style={{ color: 'red', textAlign: 'center', margin: '20px', fontSize: '16px' }}>
                                    {msgError}{' '}{msgError === 'Email ya tiene cuenta creada' && <Link to="/login" style={{ color: '#8E24AA' }}>Inicia sesión aquí</Link>}
                                </div>
                            }

                            {loading &&
                                <div className='text-center'><CircularProgress color="secondary" /></div>
                            }

                            {!loading &&
                                <button
                                    type="submit"
                                    className={'btn p-text-enviar d-flex justify-content-center align-items-center mt-4'}
                                >
                                    <span>Crear cuenta</span>
                                </button>
                            }

                            <div className='mt-4 text-center'>
                                <div className='text-[14px]'>Al crear una cuenta estás aceptando los</div>
                                <div>
                                    <Link to="#" style={{ color: '#8E24AA' }}>Términos de servicio</Link> y <Link to="#" style={{ color: '#8E24AA' }}>Privacidad</Link></div>
                            </div>

                        </form>
                    }


                </div>
            </div >
        </div >
    )
}
